import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=6ad742cc&scoped=true&"
import script from "./RetrievePassword.vue?vue&type=script&lang=js&"
export * from "./RetrievePassword.vue?vue&type=script&lang=js&"
import style0 from "./RetrievePassword.vue?vue&type=style&index=0&id=6ad742cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad742cc",
  null
  
)

export default component.exports